/**
 * Generated by `./scripts/prebuild/generate-icons-experimental.ts`.
 * Run `yarn generate-icons` to regenerate.
 */
import React, { useContext } from 'react';
import { EncoreContext, encoreContextKeyword, encoreContextStatus, getStatus } from "../../../../contexts/EncoreContext";
import { Experimental__Icon, findClosestGlyphAvailable } from "../../";
/**
 * @deprecated The name Experimental__IconChartDown is deprecated and will be archived soon. Use IconChartDown instead.
 */

export function Experimental__IconChartDown(props) {
  var iconList = [{
    size: 16,
    svgContent: "<path d='M3 6l5 5.794L13 6z'/>"
  }, {
    size: 24,
    svgContent: "<path d='M4 8l7.999 9.271L20 8z'/>"
  }, {
    size: 32,
    svgContent: "<path d='M6.192 10.001l9.999 11.587 10.001-11.587z'/>"
  }, {
    size: 48,
    svgContent: "<path d='M40 16L24.001 34.54 8 16z'/>"
  }, {
    size: 64,
    svgContent: "<path d='M12 22.001l19.998 23.176L52 22.001z'/>"
  }];
  var iconListRedraw = [{
    size: 16,
    svgContent: "<path d='M14 6l-6 6-6-6h12z'/>"
  }, {
    size: 24,
    svgContent: "<path d='M19 9l-7 7-7-7h14z'/>"
  }];
  var config = useContext(EncoreContext);
  var status = getStatus(encoreContextKeyword.icon, config);
  var iconListFallback = iconList.length === 0 ? iconListRedraw : iconList;
  var closestSize = findClosestGlyphAvailable(status === encoreContextStatus.deprecated ? iconListFallback : iconListRedraw, props.iconSize || 24);

  var titleTag = function titleTag(title, titleId) {
    return title ? "<title ".concat(titleId ? "id=\"".concat(titleId, "\"") : "", ">").concat(title, "</title>") : "";
  };

  var descTag = function descTag(desc, descId) {
    return desc ? "<desc ".concat(descId ? "id=\"".concat(descId, "\"") : "", ">").concat(desc, "</desc>") : "";
  };

  var autoMirror = props.autoMirror || false;
  return /*#__PURE__*/React.createElement(Experimental__Icon, Object.assign({}, props, {
    autoMirror: autoMirror,
    viewBox: "0 0 ".concat(closestSize.size, " ").concat(closestSize.size),
    dangerouslySetInnerHTML: {
      __html: "".concat(titleTag(props.title, props.titleId)).concat(descTag(props.desc, props.descId)).concat(closestSize.svgContent)
    }
  }));
}
export default Experimental__IconChartDown;